module.exports = __webpack_public_path__ + "static/media/userTag.8af423df.svg";